/* eslint-disable react/jsx-key */
import React from "react";
import { Column } from "react-table";

import { User, UserRole } from "types/user";
import DataTable from "components/DataTable";
import AdminUserRow from "./AdminUserRow";
import { Callback } from "types";
import { SelectFilter } from "components";
import { useUser } from "context/user";

interface Props {
  users: User[];
  saveUser: Callback;
  deleteUser: Callback;
}

const UsersDataTable: React.FC<Props> = ({
  users,
  saveUser,
  deleteUser
}: Props) => {
  const { user: actor } = useUser()!;
  const data: User[] = React.useMemo(() => users, [users]);
  const columns: Column<User>[] = React.useMemo(
    () => [
      {
        accessor: "id",
        disableSortBy: true,
        Cell: ({ row: { original } }: any) => (
          <AdminUserRow
            user={original}
            saveUser={saveUser}
            deleteUser={deleteUser}
          />
        )
      },
      {
        Header: "Username",
        accessor: "username"
      },
      {
        Header: "First Name",
        accessor: "first_name"
      },
      {
        Header: "Last Name",
        accessor: "last_name"
      },
      {
        Header: "Email",
        accessor: "email"
      },
      {
        Header: "Priv Level",
        id: "privs",
        accessor: row => UserRole[row.privs],
        Filter: SelectFilter,
        filter: "equals"
      },
      {
        Header: "Organization",
        id: "organization_display_name",
        accessor: row => row.organization?.displayName,
        disableSortBy: actor.privs <= UserRole.OrgAdmin,
        Filter: SelectFilter,
        filter: "equals",
        disableFilters: actor.privs <= UserRole.OrgAdmin
      }
    ],
    []
  );

  return <DataTable columns={columns} data={data} tableTitle="Coaches" />;
};

export default UsersDataTable;
